<template>
  <layouts-auth>
    <layouts-auth-width>
      <div class="padding-auth-contents">
        <h1 class="text-title-underline">{{ t('recommend.title') }}</h1>
        <recommend-course-list-contents />
      </div>
    </layouts-auth-width>
  </layouts-auth>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

import LayoutsAuth from '@/layouts/Auth.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import RecommendCourseListContents from '@/components/RecommendCourseListContents.vue'

export default defineComponent({
  components: {
    LayoutsAuth,
    LayoutsAuthWidth,
    RecommendCourseListContents
  },
  setup() {
    const { t } = useI18n()

    return {
      t
    }
  }
})
</script>
